import React, { useState, useEffect } from "react";
import "./navbar.css";
import { Menu, X, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "../images/logo-intrading (2).jpeg";
import { HashLink } from "react-router-hash-link";

const Navbar = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobileView = window.innerWidth <= 1024;
      setIsMobile(mobileView);

      if (!mobileView && mobileMenu) {
        setMobileMenu(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [mobileMenu]);

  const handleLinkClick = () => {
    setMobileMenu(false);
  };

  const navLinks = [
    {
      name: "Home",
      path: "/",
    },
    {
      name: "About",
      path: "/about",
    },
   
   
    {
      name: "Certification",
      path: "/certification",
    },
     {
      name: "International Fairs & media",
      path: "/international-fairs-media",
    },
    {
      name: "Contact",
      path: "/contact",
    },
  ];

  return (
    <header className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
      <div className="navbar-container">
        {/* Logo */}
        <div className="logo">
          <div className="logo-wrapper">
            <Link to="/">
              <img src={logo} alt="Intrading Logo" />
            </Link>
          </div>
        </div>

        {/* Desktop Menu */}
       <nav className="desktop-menu">
  {navLinks.map((item, index) => (
    <Link key={index} to={item.path} className="nav-link">
      <span>{item.name}</span>
    </Link>
  ))}

  <HashLink smooth to="/#machinery" className="nav-link">
    <span>Machinery</span>
  </HashLink>
</nav>

        {/* Mobile Icon */}
        <div
          className="mobile-icon"
          onClick={() => setMobileMenu(!mobileMenu)}
        >
          {mobileMenu ? <X size={28} /> : <Menu size={28} />}
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu-overlay ${mobileMenu ? "active" : ""}`}>
        <div className="mobile-menu-container">
          <div className="mobile-nav-links">
            {navLinks.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                onClick={handleLinkClick}
              >
                <span>{item.name}</span>
                <ChevronRight size={18} />
              </Link>
            ))}
            <HashLink
  smooth
  to="/#machinery"
  onClick={handleLinkClick}
>
  <span>Machinery</span>
  <ChevronRight size={18} />
</HashLink>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;